<template>
    <button-list v-bind:items="buttons" v-bind:onclick="onclick"></button-list>
</template>

<script>

    import ButtonList from "./ButtonList.vue"

    export default {
        name: "YesNoButtonList",
        components: {
            ButtonList
        },
        data: function() {
            return {
                buttons: [
                    { text: "Yes", value: true },
                    { text: "No", value: false }
                ]
            }
        },
        props: {
            items: Array,
            onclick: Function
        }
    }
</script>
